import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ActionWithConfirmationTextComponent, ConfirmationData } from "../action-with-confirmation-text/action-with-confirmation-text.component";

@Component({
    selector: "app-action-download",
    templateUrl: "../action-with-confirmation-text/action-with-confirmation-text.component.html",
    styleUrls: ["../action-with-confirmation-text/action-with-confirmation-text.component.scss"],
})
export class ActionDownloadComponent extends ActionWithConfirmationTextComponent {
    constructor(
        public override dialogRef: MatDialogRef<ActionDownloadComponent>,
        @Inject(MAT_DIALOG_DATA) public override data: ConfirmationData,
    ) {
        super(dialogRef, data);
        this.title = "Download";
        this.confirmationAction = this.title.toLowerCase();
        this.disclaimer = "Please note, as files may contain malicious content, we recommend opening them in an isolated environment.";
    }
}
